import { Injectable } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { Message } from '../publisher/message';
import { PublisherService } from '../publisher/publisher.service';
import { HeaderMenuComponent } from './header-menu.component';

export type HeaderMode = 'label' | 'items' | 'none';

@Injectable()
export class HeaderService {
    showPopup: boolean = false;
    showArrow: boolean = false;
    activeItem: string = '';
    defaultItemLabel: string = ' Project Management';
    headerComponent: HeaderMenuComponent;
    mode: HeaderMode = 'items';

    labelValue: string = '';
    constructor(
        private pubService: PublisherService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.pubService.subscribeToChannel('clicked-outside').subscribe(
            (msg: Message) => {
                if (msg.Owner !== this)
                    this.showPopup = false;
            }
        )
    }
    updateHeaderComponent(headerComp: HeaderMenuComponent) {
        this.headerComponent = headerComp;
    }
    setLabelMode(value: string) {
        this.mode = 'label';
        this.labelValue = value;
        this.showArrow = true;
    }

    setNoneMode() {
        this.labelValue = '';
        this.activeItem = '';
        this.showArrow = false;
        this.mode = 'none';
        this.headerComponent.refreshChanges();
    }

    itemClicked() {
    }

    popupClicked(itemName: string) {
        if (itemName === '') {
            this.navigateHome();
        }
        this.showPopup = false;
    }

    navigateHome() {
        this.router.navigate(['']);
        this.showArrow = false;
    }

    navigate(value:string) {
        this.router.navigate([value], {relativeTo: this.route});
    }

}



// WEBPACK FOOTER //
// ./src/app/headerfooter/header.service.ts